import { render, staticRenderFns } from "./InformationDrawer.vue?vue&type=template&id=94b8f56e&scoped=true&"
import script from "./InformationDrawer.vue?vue&type=script&lang=js&"
export * from "./InformationDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b8f56e",
  null
  
)

export default component.exports